import React from 'react';
import PropTypes from 'prop-types';
import { TEXT_LABELS } from '../constants/TextLabelConstants';
import { FONTS } from '../constants/Fonts';
import { getImageForRoomType } from './base/HousieRoomTypeCard';

const RapHousieListItem = ({
  roomName,
  roomTypeLabel = TEXT_LABELS.RAP_HOUSIE_FAMILY_ROOM_LABEL,
  roomTypeImage = getImageForRoomType('Family'),
  onClick,
}) => {
  return (
    <div
      style={{
        position: 'relative',
        width: '100%',
        height: 88,
        marginBottom: 12,
        borderRadius: 22,
        background: 'linear-gradient(90deg, #781FFF 1%, #6300C5 99%)',
        border: '0.5px solid #A3B5FF',
        display: 'flex',
        alignItems: 'center',
        padding: 5,
        boxSizing: 'border-box',
      }}
    >
      <div
        style={{
          flex: 1,
          height: '100%',
          borderRadius: 16,
          border: '1px dashed #FFFFFF',
          display: 'flex',
          alignItems: 'center',
          padding: 5,
          boxSizing: 'border-box',
        }}
      >
        <div
          style={{
            flex: 1,
            height: '100%',
            borderRadius: 12,
            border: '0.4px solid #5108AA',
            background: 'linear-gradient(218deg, #934BFF 0%, #6D00F3 100%)',
            boxShadow: 'inset -2px -2px 15px rgba(98,0,82,0.5)',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'space-between',
            padding: '0 16px',
            gap: 12,
          }}
        >
          <div style={{ display: 'flex', alignItems: 'center', gap: 12, minWidth: 0 }}>
            <img
              src={roomTypeImage}
              alt={roomTypeLabel}
              style={{
                width: 53,
                height: 35,
                objectFit: 'cover',
                borderRadius: 6,
                flexShrink: 0,
              }}
            />
            <div style={{ minWidth: 0 }}>
              <div
                style={{
                  fontFamily: FONTS.INTER_REGULAR,
                  fontWeight: 400,
                  fontSize: 12,
                  lineHeight: '20px',
                  letterSpacing: 0.8,
                  color: '#FFFFFF',
                }}
              >
                {roomTypeLabel}
              </div>
              <div
                style={{
                  fontFamily: FONTS.INTER_SEMIBOLD,
                  fontWeight: 600,
                  fontSize: 16,
                  lineHeight: '24px',
                  letterSpacing: 0.8,
                  color: '#FFFFFF',
                  whiteSpace: 'nowrap',
                  overflow: 'hidden',
                  textOverflow: 'ellipsis',
                }}
              >
                {roomName}
              </div>
            </div>
          </div>

          <button
            type="button"
            onClick={onClick}
            style={{
              position: 'relative',
              height: 34,
              minWidth: 80,
              padding: '0 18px',
              borderRadius: 100,
              border: '1px solid #FFC5F7',
              background: 'linear-gradient(90deg, #822AFF 0%, #FF00F2 100%)',
              boxShadow: '0px 4px 0px rgba(0,0,0,0.64), inset 2px 2px 5px rgba(255,255,255,0.35), inset -2px -2px 6px rgba(0,0,0,0.25)',
              color: '#FFFFFF',
              fontFamily: FONTS.INTER_MEDIUM,
              fontWeight: 500,
              fontSize: 14,
              lineHeight: '22px',
              textTransform: 'uppercase',
              cursor: 'pointer',
              flexShrink: 0,
            }}
          >
            {TEXT_LABELS.RAP_HOUSIE_START_GAME_BUTTON_VIEW}
          </button>
        </div>
      </div>
    </div>
  );
};

RapHousieListItem.propTypes = {
  roomName: PropTypes.string.isRequired,
  roomTypeLabel: PropTypes.string,
  roomTypeImage: PropTypes.string,
  onClick: PropTypes.func,
};

export default RapHousieListItem;
